import React, { useState, useMemo } from 'react';
import { Search } from 'lucide-react';
import { jobs } from '../data/jobs';
import JobCard from '../components/jobs/JobCard';

const JobsPage = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredJobs = useMemo(() => {
    const query = searchQuery.toLowerCase().trim();
    
    if (!query) return jobs;

    return jobs.filter(job => {
      return (
        job.title.toLowerCase().includes(query) ||
        job.department.toLowerCase().includes(query) ||
        job.description.toLowerCase().includes(query) ||
        job.skills.required.some(skill => skill.toLowerCase().includes(query)) ||
        job.skills.preferred.some(skill => skill.toLowerCase().includes(query))
      );
    });
  }, [searchQuery]);

  return (
    <div className="pt-20">
    <div className="bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Join the Adventure</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover our volunteer opportunities and help make technology accessible to all students
          </p>
        </div>

          <div className="max-w-3xl mx-auto mb-12">
            <div className="relative">
              <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Search by job, department, or skill…"
                className="w-full pl-12 pr-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#0139B7] focus:border-transparent"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>

          <div className="grid gap-6">
            {filteredJobs.length > 0 ? (
              filteredJobs.map((job) => (
                <JobCard key={job.id} job={job} />
              ))
            ) : (
              <div className="text-center py-12">
                <p className="text-gray-500 text-lg">
                No position matches your search.
                </p>
                <button
                  className="mt-4 text-[#0139B7] hover:underline"
                  onClick={() => setSearchQuery('')}
                >
                  Reset the search
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobsPage;